var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"yes-no-container"},[_c('div',{class:{ active: _vm.value }},[_vm._v("YES")]),_c('div',[_vm._v("/")]),_c('div',{class:{ active: !_vm.value }},[_vm._v("NO")])])}
var staticRenderFns = []

export { render, staticRenderFns }